import { useState, type FC} from 'react'

import { List, ListItemButton, ListItemIcon, ListItemText, Collapse } from "@mui/material"
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Link } from 'react-router-dom'


export interface MenuItemProps { 
    title: string, 
    link?: string,
    subItems?:MenuItemProps[], 
    icon?:React.ReactElement,
    onClick?: React.MouseEventHandler<HTMLDivElement>
}

export const MenuItem: FC<MenuItemProps> = ({
    title, 
    link,
    subItems, 
    icon,
    onClick
}) => {

    const [collapseClosed, setCollapseClosed] = useState<boolean>(false)

    if(subItems && subItems.length > 0){
        
        const content = subItems?.map( (item, key) => {
            return(
                <Link to={item.link || ''} key={key} style={{color:'inherit', textDecoration: 'none'}}>
                    <ListItemButton onClick={onClick}>
                        <ListItemIcon></ListItemIcon>
                        <ListItemText primary={item.title} />
                    </ListItemButton>
                </Link>
            )
        })

        return (
            <>
                <ListItemButton onClick={() => setCollapseClosed(!collapseClosed) }>
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText sx={{ fontWeight: 600}}>{title}</ListItemText>
                    {collapseClosed ? <ExpandLess/> : <ExpandMore/>}
                </ListItemButton>
                <Collapse in={collapseClosed} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {content}
                    </List>
                </Collapse>
            </>
        )
    }
    else {
        return  (
            <Link to={link || ''} style={{color:'inherit', textDecoration: 'none'}}>
                <ListItemButton onClick={onClick}>
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText primary={title} />
                </ListItemButton>
            </Link>
        )
    }
}